import React from 'react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { toolbarWrapper } from '../../users/UsersStyles';
import { bodyContent } from './Headers.styles';

interface SubheaderWithCommandBarProps {
  title: () => JSX.Element;
  children?: JSX.Element;
}
const BodyHeaderWithCommandBar: React.FunctionComponent<SubheaderWithCommandBarProps> = (
  props: SubheaderWithCommandBarProps,
) => {
  const { title, children } = props;

  const Styles = bodyContent();
  return (
    <Stack horizontal horizontalAlign="space-between" verticalAlign="center" wrap>
      <Stack horizontal verticalAlign="center" className={Styles.bodyContentTitle}>
        {title()}
      </Stack>
      <Stack grow horizontal verticalAlign="center" horizontalAlign="end">
        <StackItem className={toolbarWrapper}>{children}</StackItem>
      </Stack>
    </Stack>
  );
};
export default BodyHeaderWithCommandBar;
